import React from 'react'
import {connect} from 'react-redux'
import {getLinks, setLinksFilter} from 'state/actions'
import ga from 'react-ga'
import styles from './links.scss'
import Category from './categories'
import FilterInput from 'elements/FilterInput'
import {sortBy} from 'lodash/collection'

import i18n from 'lib/i18n'
const _ = i18n('links')

@connect(
	state => ({
		items: state.links.items,
		filter: state.links.filter,
	}),
	{getLinks, setLinksFilter}
)
export default class Links extends React.Component {
	static propTypes = {
		items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
		filter: React.PropTypes.string.isRequired,
	}
	componentDidMount() {this.update()}
	update() {this.props.getLinks()}
	orderItems(items) {
		const cats = {}
		items.forEach(item => {
			const {categoryId, text, href} = item
			if (!cats[categoryId]) {cats[categoryId] = []}
			cats[categoryId].push({text, href})
		})
		return Object.keys(cats).map(categoryId => {
			const sortCats = sortBy(cats[categoryId], cat => cat.text.toLowerCase().replace(/\s+/g, ''))
			return {categoryId, content: sortCats}
		})
	}
	linkClicked(link) {
		ga.event({
			category: "External link",
			action: (`Redirected to ${link}`),
		})
	}
	render() {
		const {items, filter, setLinksFilter} = this.props
		const itemsId = items.map((m, i) => ({...m, id: i}))
		const lowerFilter = filter.toLowerCase()
		const filteredItems = filter ?
			itemsId.filter(item => item.text.toLowerCase().includes(lowerFilter)) :
			itemsId
		const theItems = this.orderItems(filteredItems)
		return (
			<div id={`${styles.linksModule}`}>
				<div className={`${styles.mainSubDiv}`}>
					<div className={`${styles.mainTitleDiv} ${styles.bottomBorder}`}>
						<div className={`${styles.mainTitleContainer}`}>
							<h2 className={`${styles.mainTitle}`}>{_('title')}</h2>
							<h3>{_('subtitle')}</h3>
						</div>
						<FilterInput filter={filter} setFilter={setLinksFilter}/>
					</div>
					<div>
						{theItems.map((item, i) =>
							<div key={`cat${i}`} className={`${styles.link}`}>
								<div className={`${styles.text}`}>
									<Category plain id={item.categoryId}/>
								</div>
								<div className={`${styles.content}`}>
									{item.content.map((link, i) =>
										<div key={i} className={`${styles.ref}`}>
											<a href={link.href} target="_blank" onClick={() => this.linkClicked(link.href)} rel="noopener noreferrer">
												{link.text}
												<span className={`${styles.textLink}`}>{link.href}</span>
											</a>
										</div>
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/links.jsx